import { openSubscribeDialog } from 'https://www.pushcode.jp/dist/pushcode-components/index.esm.js';

(() => {
    const getUserId = function() {
        //
        if (ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page) {
            const customerId = ShopifyAnalytics.meta.page.customerId;
            if (customerId) {
                return customerId.toString();
            }
        }

        //
        //
        const currentUserId = window.localStorage.getItem('pushcode_userid');
        if (currentUserId) {
            return currentUserId;
        }

        //
        return uuidv4();
    }

    //
    const uuidv4 = function() {
        if (crypto && crypto.randomUUID) {
            return crypto.randomUUID();
        }
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    // https://stackoverflow.com/a/56592365/9069921
    const pickProperties = function(obj, props) {
        return props
            .reduce(function(obj2, key) {
                if (key in obj) // line can be removed to make it inclusive
                    obj2[key] = obj[key];
                return obj2;
            }, {});
    }

    const trimCart = function(cart) {
        cart.items.forEach(function(item, i) {
            cart.items[i] = trimItem(item);
        });

        const trimmedCart = pickProperties(cart, ['token', 'currency', 'item_count', 'items', 'total_price']);
        trimmedCart.total_price /= 100;
        return trimmedCart;
    }

    const trimItem = function(item) {
        const trimmedItem = pickProperties(item, ['id', 'variant_id', 'sku', 'quantity', 'product_title', 'price', 'url'])
        trimmedItem.price /= 100;
        return trimmedItem;
    }

    const sendCartEvent = function(pushcode, cart) {
        const data = {
            pushcode,
            cart
        }

        const fetchOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }

        return fetch('https://event.pushcode.jp/browser/api/v1/shopify/cart_update', fetchOptions);
    }

    const getCartState = function() {
        const cartString = window.localStorage.getItem('pushcode_cart');
        if (!cartString) {
            return null;
        }
        return JSON.parse(cartString);
    }

    const setCartState = function(state) {
        if (state) {
            window.localStorage.setItem('pushcode_cart', JSON.stringify(state));
        }
    }

    const deleteCartState = function() {
        window.localStorage.removeItem('pushcode_cart');
    }

    const toSnakeCase = function(s) {
        return s
            .replace(/[A-Z]+(?:(?=[A-Z][a-z0-9])|$)/g, function(ss) { return ss.charAt(0) + ss.slice(1).toLowerCase() })
            .replace(/[A-Z]/g, function(ss) { return '_' + ss.charAt(0).toLowerCase() });
    }

    const objectToString = function(obj) {
        return obj instanceof Error ? obj + '' : JSON.stringify(obj);
    }

    const objectToQuery = function(obj) {
        return Object.keys(obj).map(function(k) {
            return toSnakeCase(k) + '=' + encodeURIComponent(typeof (obj[k]) === 'object' ? objectToString(obj[k]) : obj[k])
        }).join('&');
    }

    const sendEvent = function(name, misc) {
        var params = misc && Object.keys(misc).length > 0 ? '&' + objectToQuery(misc) : '';
        return fetch('https://event.pushcode.jp/browser/api/v1/push_event?type=' + name + params,{method:'GET'});
    }

    const sendError = function(log, misc) {
        if (!misc) {
            misc = {};
        }
        misc.file = 'pushcode_shopify_init.js';
        misc.log = log;
        return sendEvent('error', misc);
    }

    const updateCartStatus = function() {
        // get cart ajax
        return fetch('/cart.json',{method:'GET'}).then(function(res) {
            if (res.ok) {
                res.json().then(function(cart) {
                    let oldCart = getCartState();

                    // create object to send as event and save to localstorage
                    cart = trimCart(cart);

                    // if cart is empty and there is no cart state
                    if (cart.item_count < 1 && !oldCart) {
                        return;
                    }

                    if (oldCart) {
                        // if cart token is different and old cart has items
                        if (oldCart.token !== cart.token && oldCart.item_count > 0) {
                            // empty old cart
                            oldCart.item_count = 0;
                            oldCart.total_price = 0;
                            oldCart.items = [];
                            sendCartEvent(PushCode, oldCart).then(function() {
                                setCartState(cart);
                            });
                        }

                        // if no change
                        if (oldCart.token === cart.token && oldCart.item_count === cart.item_count && oldCart.total_price === cart.total_price) {
                            return;
                        }

                        // if current cart is empty, clear cart status
                        if (cart.item_count < 1) {
                            deleteCartState();
                            return;
                        }
                    }

                    // TODO: implement retry
                    sendCartEvent(PushCode, cart).then(function() {
                        // save cart to localstorage
                        setCartState(cart);
                    });
                });
            }
        }).catch(function(e) {
            console.error(e);
            sendError('Failed to update cart status', {
                error: e,
                pushcode: pushcode
            });
        });
    }

    const init = function() {
        try {
            if (PushCode && PushCode.isSupport()) {
                var is_pushcode_new_released = parseInt(localStorage.getItem('is_pushcode_new_released') || 0);
                var key_release_date = 202302;
                if (!PushCode.isSubscribed()) {
                    var pushcode_deny_date = Date.parse(localStorage.getItem('pushcode_deny_date'));
                    var pushcode_display_count = parseInt(localStorage.getItem('pushcode_display_count') || 0);
                    if (is_pushcode_new_released != key_release_date) {
                        pushcode_display_count = 0;
                        localStorage.removeItem('pushcode_subscribed');
                        localStorage.removeItem('pushcode_deny_date');
                        localStorage.removeItem('pushcode_component_show_state');
                        localStorage.setItem('is_pushcode_new_released', 202302);
                        localStorage.setItem('pushcode_display_count', pushcode_display_count);
                    } else {
                        if (!isNaN(pushcode_deny_date)) {
                            var pushcode_current_date = new Date();
                            var pushcode_diffTime = pushcode_current_date - pushcode_deny_date;
                            var pushcode_diffDays = pushcode_diffTime / (1000 * 60 * 60 * 24);
                            if (pushcode_diffDays >= 7 && pushcode_display_count < 2) {
                                localStorage.removeItem('pushcode_subscribed');
                                localStorage.removeItem('pushcode_deny_date');
                                dataLayer.push({ 'event': 'pushcode retry after deny' });
                            }
                        }
                    }
                }

                if (!PushCode.components) {
                    PushCode.components = {};
                    PushCode.components.openSubscribeDialog = openSubscribeDialog;
                }

                const userid = getUserId();

                PushCode.init({
                    domainToken: 'f912bea0e24c062d97052a480ed4dbd846e5b57cd58c39c9d1ffa86b7c8c1410',
                    userid: userid,
                    serviceWorkerPath: '/apps/pushcode/pushcode_sw.js',
                    scopePath: '/apps/pushcode/',
                    useConsoleConfig: true,
                });

                if (PushCode.components && pushcode_display_count<2) {

                  var send_pushcode_event=true;
                  var isDomainTokenValid = PushCode.getDomainTokenValid();
                  if (isDomainTokenValid != null && isDomainTokenValid != "1") {
                    send_pushcode_event=false;
                  }

                  if (PushCode.permission() === PushCode.permissions().denied) {
                    send_pushcode_event=false;
                  }

                  if (PushCode.isSubscribed() !== PushCode.subscribeStates().default) {
                    if (!(PushCode.permission() === PushCode.permissions().default && PushCode.isSubscribed() === PushCode.subscribeStates().subscribed)) {
                      send_pushcode_event=false;
                    }
                  }

                  // if subscribe state is default and permission is already granted, don't show modal
                  if (PushCode.isSubscribed() === PushCode.subscribeStates().default && PushCode.permission() === PushCode.permissions().granted) {
                    send_pushcode_event=false;
                  }
                    
                    var not_display_dialog = 0;
                    if (is_pushcode_new_released != key_release_date) {
                        send_pushcode_event = false;
                        not_display_dialog = 1;
                    }


                    if(send_pushcode_event){
                      pushcode_display_count = pushcode_display_count + 1;
                      localStorage.setItem('pushcode_display_count', pushcode_display_count);
                      dataLayer.push({'event': 'pushcode dialog open'});
                    }

                    if (!not_display_dialog) {
                        PushCode.components.openSubscribeDialog({
                            allowHtml: true,
                            position: "top-left",
                            message: "<div style='font-family: \"Noto Sans JP\",sans-serif;position:relative;text-align:center;'><div class='pushcode-wrap'><div class='pushcode-image'><img style='width: 100%;' src='https://storage.googleapis.com/pushcode-webflow-assets/kanademono_icon.png'></div><div class='pushcode-message'><div class='pushcode-title'>最新のお得な情報をお知らせします</div><div class='pushcode-body'><div style='margin-bottom:4px;'>次のポップアップで”許可”を選択してください</div><img src='https://storage.googleapis.com/pushcode-ab-images/kanademono/permission-prompt/popup_pc.png' class='pushcode-popup-image is-pc'><img src='https://storage.googleapis.com/pushcode-ab-images/kanademono/permission-prompt/popup_sp.png' class='pushcode-popup-image is-sp'></div></div></div><style>.pushcode-wrap{display: flex;justify-content: center; align-items: center;}.pushcode-title{font-weight:normal;font-size:20px;letter-spacing:0.15px;}.pushcode-body{font-size:12px;line-height:24px;letter-spacing:0.5px;font-weight: normal;}.pushcode-image{width:72px;height:72px;margin-right:10px;padding: 4px;background: #fff;border-radius: 50%;}.pushcode-message{width:80%}.pushcode-popup-image{width:87%;vertical-align:bottom;} :host .buttons{justify-content:center !important;padding:0 20px 16px;}:host .buttons button.deny,:host .buttons button.accept{letter-spacing:1.25px;font-size:14px;font-family: \"Noto Sans JP\",sans-serif;min-width:64px;border-radius:4px;padding:7px;width: calc(100% / 2) !important;max-width: 208px;}:host .buttons button.accept,:host .buttons button.accept:hover{background-color:rgb(28,29,29);border:var(--dialog-deny-border, 1px solid transparent);}:host .buttons button.deny{background-color:rgb(234,234,234);color:var(--dialog-message-color, #606266);}.close{display:none !important;}.messageGroup{padding:14px 20px 0;background: #F3F6F8;} :host(.hydrated){box-sizing: border-box;padding:0 !important;width : 473px;max-width : 100%;border-radius : 4px !important;box-shadow:0 1px 1px 0 rgb(66 66 66 / 8%), 0 1px 3px 1px rgb(66 66 66 / 16%);}.is-sp{display: none}@media screen and (max-width: 799px){:host(.hydrated){max-width:94%;left:3% !important;}.pushcode-wrap{flex-direction: column;}.pushcode-title{font-size:18px;}.pushcode-popup-image{margin-left:18px}.messageGroup{padding:14px 20px 0}.pushcode-image{margin-right:0}.pushcode-message{width:auto}.pushcode-body{font-size:10px}:host .buttons button.deny,:host .buttons button.accept{font-size:13px;min-width:96px;padding:7px 18px;}:host .buttons button.accept{margin-left:10px}.is-pc{display: none !important;}.is-sp{display: inline-block;}}</style>",
                            subMessage: "<style>.messageGroup{max-width:none !important;}:host .buttons button.accept{background-color:rgb(28,29,29) !important;}</style>",
                            label: {
                                accept: "受け取る",
                                deny: "後で"
                            },
                            buttonsOrder: "deny-accept",
                            callbacks: {
                                accept: (function () { dataLayer.push({ 'event': 'pushcode dialog ok' }); }),
                                deny: (function () { localStorage.setItem('pushcode_deny_date', new Date().toISOString()); dataLayer.push({ 'event': 'pushcode dialog deny' }); }),
                                close: (function () { dataLayer.push({ 'event': 'pushcode dialog close' }); }),
                                grayOutClick: (function () { dataLayer.push({ 'event': 'pushcode dialog grayout' }); }),
                                requestPermission: (function (e) {
                                    if (e.permission == "granted") { dataLayer.push({ 'event': 'browser dialog ok' }); }
                                    else if (e.permission == "denied") { dataLayer.push({ 'event': 'browser dialog block' }); }
                                    else if (e.permission == "default") { dataLayer.push({ 'event': 'browser dialog default' }); }
                                }),
                            }
                        });
                    }


                } else if(pushcode_display_count<2) {
                    PushCode.requestPermission();
                }

                // if currently subscribed
                if (PushCode.getSubscribedState() && PushCode.getRegistrationState()) {
                    updateCartStatus();
                }

                // update cart status on ajax add to cart
                const attachListener = function(e) {
                    e.addEventListener('submit', function() {
                        // need to wait for ajax to complete
                        setTimeout(updateCartStatus, 1000);
                    });
                }
                window.document.querySelectorAll('form[action="/cart/add"]').forEach(attachListener);
                window.document.querySelectorAll('form[action="/cart"]').forEach(attachListener);
            }
        }
        catch (err) {
            console.error(err);
        }
    };

    init();
})();